import { createSlice } from '@reduxjs/toolkit';
import { getActivePlacementList } from '../../reducers/active/activeThunks';
import { handleRequestThunk } from '../handleRequestThunk';
import { commonInitialState } from '../../../utils/common/commonInitialState';
const SLICE_NAME = 'activePlacement';

export const activePlacementSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getActivePlacementList });
    },
});

export const selectActivePlacement = (state) => state.activePlacement.data;

export const activePlacement = activePlacementSlice.reducer;
